<template>
  <Modal :id="'dtplugins-dbox_costs-recoupables'" @cancelled="onCancel">
    <template slot="header"> {{ $t("recoupables") }} </template>
    <template slot="body">
      <NTable
        :headers="headers"
        :items="list"
        :id="'dtplugins-dbox_costs-recoupables_list dbox1'"
        :config="tableConfig"
        height="200px"
        ref="recoupList"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              disabled: item['balance_id'] != newBalanceId,
            }"
          >
            <td :title="item.balance_date" v-bind="tdcon('date')">
              <span>{{ item["balance_date"] }}</span>
            </td>
            <td  v-bind="tdcon('royalty_account')">
              <Dropdown
                v-if="item['balance_id'] == newBalanceId"
                :options="royaltyAccountsTV"
                :selected="selectedRoyaltyAccount"
                :placeholder="'Royalty Account'"
                isSearchable
                deselect
                :showExpandStatusIcon="item['balance_id'] == newBalanceId"
                :disabled="item['balance_id'] != newBalanceId"
                v-on:selectedChange="(e) => onRoyaltyAccountSelected(item, e)"
                :loadingFlag="royaltyLoadingFlag"
                @searched="onRoyaltyAccountSearch"
              ></Dropdown>
              <span :title="item.royalty_account_name" style="color: black" v-else class="ut-text-secondary">
                {{ item["royalty_account_name"] }}
              </span>
            </td>
            <td v-bind="tdcon('contract')">
              <Dropdown
                v-if="item['balance_id'] == newBalanceId"
                :options="contractsTV"
                :selected="selectedContract"
                :placeholder="'Contract'"
                isSearchable
                deselect
                :showExpandStatusIcon="item['balance_id'] == newBalanceId"
                :disabled="item['balance_id'] != newBalanceId"
                v-on:selectedChange="(e) => onContractSelected(item, e)"
                :loadingFlag="contractLoadingFlag"
                @searched="onContractSearch"
              ></Dropdown>
              <span :title="item.contract_name" style="color: black" v-else class="ut-text-secondary">
                {{ item["contract_name"] }}
              </span>
            </td>
            <td :title="item.description" v-bind="tdcon('text')">
              <span>{{ item["description"] }}</span>
            </td>
            <td :title="item.orig_curr" v-bind="tdcon('currency')">
              <span>{{ item["orig_curr"] }}</span>
            </td>
            <td v-bind="tdcon('amount')">
              <TextField2
                :title="item['amount']"
                type="text"
                :showLabel="false"
                name="amount"
                class="dbox1"
                id="amount"
                :disabled="item['balance_id'] != newBalanceId"
                :highlight="item['balance_id'] == newBalanceId"
                :value="item['amount']"
                :bb="'none'"
                @change="(e) => onTextFieldChange(e, item)"
                @blur="(e) => updateTextfield(e, item)"
              />
            </td>
            <td v-bind="tdcon('options')">
              <div v-if="!item.valid_rp" style="padding-left: 2px" class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onDeleteCostBalace(item)"
                  alt="Delete Invoice Line"
                  title="Delete Invoice Line"
                />
              </div>
            </td>
          </tr>
        </template>
        <!-- <template v-slot:tfoot="{ thcon }">
          <tr>
            <td
              v-bind="thcon('date')"
              style="overflow: visible; position: relative"
            >
              <span style="width: max-content; position: absolute"
                >Total Recoupment in
                {{ $store.getters.account.client.default_currency }}
              </span>
            </td>
            <td v-bind="thcon('royalty_account')"></td>
            <td v-bind="thcon('contract')"></td>
            <td v-bind="thcon('text')"></td>
            <td v-bind="thcon('currency')">
              <span>EUR</span>
            </td>
            <td v-bind="thcon('amount')">
              <span>
                {{ $dft.curr(totalRecoup) }}
              </span>
            </td>
            <td v-bind="thcon('options')"></td>
          </tr>
        </template> -->
      </NTable>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding:5px 35px 0 10px;
         
          
        "
      >
        <span style="width: max-content"
          >Total Recoupment in
          {{ $store.getters.account.client.default_currency }}
        </span>
        <div>
          <span style="font-weight: 600">
          {{ $dft.curr(totalRecoup) }}
        </span>
        <span> {{ $store.getters.account.client.default_currency }}</span>
        </div>
      </div>
      <div class="ut-flex" style="margin-top: 10px">
        <button
          @click="onNewBalanceClick"
          style="font-weight: normal"
          class="dt-button v3 c5"
        >
          + Add New Balance
        </button>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.capHead($t("close")) }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import { DBoxCostService } from "./dbox-costs.service";
import { createTV } from "../../models/text-value.model";
import {
  createFormItemMixin,
  createFormModalMixin,
} from "../form-modal/form-modal";
import { isValidNumber, subscribeSubject } from "../../utility";
import { createValidator } from "../../plugins/text-field";
import { Subject } from "rxjs";
import { isBefore, isEqual } from "date-fns";
import { createNTableConfig, createTableHeader } from "../../plugins/datatable";
import { confirmDelete } from "../confirmation/confirmation-common";

export default {
  components: {
    Modal,
    InputField,
    NTable,
  },
  props: ["config", "status"],
  mixins: [],
  async mounted() {
    const costRecoupRes = await DBoxCostService.fetchCostReoupables({
      cost_split_id: this.cost_split_id,
    });
    this.costRecoupData = costRecoupRes?.data;
    console.log({ "this.costRecoupData": this.costRecoupData });
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        immediateValidation: true,
      },
      openAdvance: this.resetOpenAdvance(),
      costRecoupData: null,
      validationResult: {},

      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        footer: false,
      }),

      newBalanceId: "",

      royaltyAccounts: [],
      selectedRoyaltyAccount: {},

      contracts: [],
      selectedContract: {},

      royaltyLoadingFlag: false,
      contractLoadingFlag: false,
    };
  },
  computed: {
    cost_split_id: function () {
      return this.$route.query.cost_split_id;
    },
    headers: function () {
      return [
        createTableHeader("date", { mw: 120 }),
        createTableHeader("royalty_account", { f: 2 }),
        createTableHeader("contract", { f: 1.75 }),
        createTableHeader("text", { f: 2.5 }),
        createTableHeader("currency", { ta: "right", mw: 65 }),
        createTableHeader("amount", {}),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
    totalRecoup() {
      return this.list
        .map((e) => {
          // console.log(e.amount);
          return +e.amount;
        })
        .reduce((accm, cur) => accm + cur, 0);
      // return 0;
    },
    list() {
      return (this.costRecoupData && this.costRecoupData.balances) || [];
    },
    royaltyAccountsTV() {
      return createTV(
        this.royaltyAccounts,
        "royalty_account_name",
        "royalty_account_id"
      );
    },
    contractsTV() {
      return createTV(this.contracts, "contract_name", "contract_id");
    },
  },
  methods: {
    onOkClick: async function () {
      const cs = this.advanceData.cs;

      const advanceMade = await DBoxCostService.makeAccountAdvance({
        orig_curr: cs.currency,
        cost_group_id: cs.cost_group_id,
        cost_amount_sys_curr: cs.amount,
        cost_amount_orig_curr: cs.amount_orig_curr,
        cost_amount_roy_curr: cs.amount, // ?????
        balance_date: this.openAdvance.date,
        amount: this.openAdvance.amount,
        balance_type: 1,
        amount_sys_curr: this.openAdvance.amount,
        description: cs.description,
        cost_split_id: cs.cost_split_id,
        royalty_account_id: this.openAdvance.royalty_account,
        contract_id: this.openAdvance.contract,
        debit_credit_flag: 1,
        external_id: this.config.primaryKeyValue,
        external_table: this.config.externalTable,
      });
      this.$emit("advance_made", {
        cost_split_id: this.cost_split_id,
        recoupable_txt: advanceMade.data.recoupable_txt,
      });
    },
    onCancel: function () {
      this.$emit("cancelled", this.cost_split_id);
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onTextFieldValueChange(name, value) {
      this.openAdvance = {
        ...this.openAdvance,
        [name]: value,
      };
    },
    async onDropdownChange(name, value) {},
    resetOpenAdvance() {
      return {
        royalty_account: null,
        contract: null,
        date: null,
        currency: null,
        amount_orig_curr: null,
        amount: null,
        description: null,
        next_stmt_date: null,
      };
    },
    checkAlreadyCalcStatement(value) {
      // console.log({
      //   "this.openAdvance?.next_stmt_date": this.openAdvance
      //     ?.next_stmt_date,
      // });
      // console.log({ value: value });
      if (this.openAdvance?.next_stmt_date) {
        return (
          isBefore(this.openAdvance?.next_stmt_date, value) ||
          isEqual(this.openAdvance?.next_stmt_date, value)
        );
      } else {
        return true;
      }
    },
    async onDeleteCostBalace(item) {
      // const confirmationResult = await confirmDelete(
      //   "Balance",
      //   `ID: ${item.balance_id} ${
      //     item.amount ? "Amount: " + item.amount : " "
      //   }`
      // );
      // if (confirmationResult == "OK") {
      this.costRecoupData = {
        ...this.costRecoupData,
        balances: this.costRecoupData.balances.filter(
          (e) => e.balance_id != item.balance_id
        ),
      };

      await DBoxCostService.removeBalance({
        balance_id: item.balance_id,
      });
      //}
    },
    onTextFieldChange({ name, value }, item) {
      // console.log(item, { name, value });
      const { balance_id } = item;
      this.costRecoupData = {
        ...this.costRecoupData,
        balances: this.costRecoupData.balances.map((e) => {
          if (e.balance_id == balance_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        }),
      };
      // console.log(this.costRecoupData.balances);
    },
    async onNewBalanceClick() {
      const newBalanceRes = await DBoxCostService.insertCostBalance({
        cost_split_id: this.cost_split_id,
      });
      this.costRecoupData = {
        ...this.costRecoupData,
        balances: newBalanceRes?.data?.balances,
      };

      // Resetting The new Balance Values
      this.newBalanceId = newBalanceRes?.data?.balance_id;
      this.selectedRoyaltyAccount = {};
      this.selectedContract = {};

      this.$nextTick(() => {
        this.$refs["recoupList"].scrollToBottom();
      });
    },
    async updateTextfield({ name, value }, item) {
      // console.log(name, value);
      const { balance_id } = item;
      const updatedBalance = await DBoxCostService.updateBalance({
        balance_id,
        amount: value,
        cost_split_id: this.cost_split_id,
      });
    },
    async onRoyaltyAccountSearch(string) {
      // console.log({ string: string });
      this.royaltyLoadingFlag = true;
      const searchRes = await DBoxCostService.searchAccounts(string);
      this.royaltyLoadingFlag = false;
      // console.log({ searchRes: searchRes });
      this.royaltyAccounts = searchRes?.data?.royalty_accounts || [];
      // console.log({
      //   "this.royaltyAccounts": this.royaltyAccounts,
      // });
    },
    async onRoyaltyAccountSelected(item, value) {
      const { balance_id } = item;
      this.selectedRoyaltyAccount = value;
      // console.log({
      //   "this.selectedRoyaltyAccount": this
      //     .selectedRoyaltyAccount.text,
      // });

      const modRes = await DBoxCostService.modifyBalance(
        balance_id,
        "royalty_account_id",
        this.selectedRoyaltyAccount.value
      );
      // console.log({ modRes: modRes });
    },
    async onContractSearch(string) {
      // console.log({ string: string });
      this.contractLoadingFlag = true;
      const searchRes = await DBoxCostService.searchContracts(string);
      this.contractLoadingFlag = false;
      // console.log({ searchRes: searchRes });
      this.contracts = searchRes?.data?.contracts || [];
      // console.log({
      //   "this.contracts": this.contracts,
      // });
    },
    async onContractSelected(item, value) {
      const { balance_id } = item;
      this.selectedContract = value;
      // console.log({
      //   "this.selectedContract": this.selectedContract.text,
      // });

      const modRes = await DBoxCostService.modifyBalance(
        balance_id,
        "contract_id",
        this.selectedContract.value
      );

      // console.log({ modRes: modRes });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.dtplugins-dbox_costs-recoupables {
  .dt-ntable {
    border: 1px solid var(--sprt-5);
    border-radius: 6px;
    border-collapse: separate;
    /* border-bottom: none; */
    background: #f8f8f8;
    tr {
      &.disabled {
        background: var(--bc-35);
      }
    }
  }
}
</style>


